import { render, staticRenderFns } from "./airVerifyBookingBasic.vue?vue&type=template&id=6faee183&scoped=true&"
import script from "./airVerifyBookingBasic.vue?vue&type=script&lang=js&"
export * from "./airVerifyBookingBasic.vue?vue&type=script&lang=js&"
import style0 from "./airVerifyBookingBasic.vue?vue&type=style&index=0&id=6faee183&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6faee183",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6faee183')) {
      api.createRecord('6faee183', component.options)
    } else {
      api.reload('6faee183', component.options)
    }
    module.hot.accept("./airVerifyBookingBasic.vue?vue&type=template&id=6faee183&scoped=true&", function () {
      api.rerender('6faee183', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/pageUICustom/airVerifyBookingBasic.vue"
export default component.exports